import { defineKey as T } from 'ha/i18n';
import { PaymentRequestState } from 'ha/services/osiris/paymentRequests';

export const STATE_NAME = 'payoutsPaymentRequests';
export const PAYMENT_REQUESTS_PER_PAGE = 10;
export const STATUS_LABELS: { [K in PaymentRequestState]: string } = {
  cancelled: T('Cancelled'),
  collected: T('Collected'),
  paid_out: T('Paid out'),
  refunded: T('Refunded'),
  unpaid: T('Unpaid'),
  overdue: T('Overdue'),
};

export const alertMessages = {
  pr_cancel_success: T('Payment request has been canceled'),
  pr_cancel_error: T('Payment request could not be canceled'),
};
